import { FilterXSS } from 'xss';

const xssFilter = new FilterXSS({
  allowList: {
    mark: ['style'],
  },
});

export const xss = xssFilter.process.bind(xssFilter);
